import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";

function CalendaModalBody({data}) {
    const navigate = useNavigate();

    return (
        <tbody className={``}>
        {data.map((each, index) => (
            <tr key={`modal_` + index}>
                <td  className={`large-listChart-table-td mobile-hidden`}>{each.dateTime?.substring(0, 10)}</td>
                <td className={`large-listChart-table-td  mobile-hidden`}>{each.title}</td>
                <td className={`large-listChart-table-td  h-[30px] line-height-30`}>{each.userName}</td>
                <td className={`large-listChart-table-td h-[30px] line-height-30 text-left overflow-ellipsis text-nowrap`}>{each.name}</td>
                <td className={`large-listChart-table-td h-[30px] line-height-30 text-center hover:cursor-pointer`} onClick={() => {
                    navigate(each.link + '/' + each.id)
                }}>
                    <FontAwesomeIcon icon={faMagnifyingGlass}
                                     className={`line-height-30`}/>
                </td>
            </tr>
        ))}
        {data?.length < 1 &&
            <tr>
                <td colSpan={5} className={`large-listChart-table-td h-[250px]`}>조회 내역이 없습니다.</td>
            </tr>
        }
        </tbody>
    );
}

export default CalendaModalBody;